import React, { useState } from 'react';
import { IClientCompanyData } from '../../ui-toolkit/orders/interfaces/IClient';
import { Show } from '../shared/Show';
import { TextButtonTW } from '../../tailwindComponents/buttonTW/TextButtonTW';
import { checkForMutationSuccess } from '../../API/checkForMutationSuccess';
import { useUpdateClientMutation } from '../../API/clients/ClientCompanyApi';
import { DeactivateClientCompanyModal } from './DeactivateClientCompanyModal';
import { useHasPermissions } from '../accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

interface ISwitchClientCompanyActivateButtonProps {
  clientCompany: IClientCompanyData;
}

export const SwitchClientCompanyActivateButton: React.FC<ISwitchClientCompanyActivateButtonProps> = ({
  clientCompany,
}) => {
  const hasDeactivatePermissions = useHasPermissions([ePermissions.ClientCompanyEdit]);
  const [deactivateClient, setDeactivateClient] = useState<boolean>(false);

  const [updateClientCompany, { isLoading }] = useUpdateClientMutation();

  const handleUpdate = async () => {
    const result = await updateClientCompany({ id: clientCompany.id, isActive: true });
    checkForMutationSuccess(result, 'Activate Client Company', 'Error Activating Client Company');
  };

  return (
    <Show when={hasDeactivatePermissions}>
      {` | `}
      <Show
        when={clientCompany.isActive}
        fallback={
          <TextButtonTW className={'font-normal !text-black'} disabled={isLoading} onClick={handleUpdate}>
            Activate
          </TextButtonTW>
        }
      >
        <TextButtonTW className={'font-normal !text-black'} onClick={() => setDeactivateClient(true)}>
          Deactivate
        </TextButtonTW>
      </Show>
      <DeactivateClientCompanyModal
        open={deactivateClient}
        setOpen={setDeactivateClient}
        clientCompany={clientCompany}
      />
    </Show>
  );
};
